import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BuildingChurchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-church",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 21l18 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 21v-4a2 2 0 0 1 4 0v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 5l4 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3l0 5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7"
    }, null), _createTextVNode(" ")]);
  }
};